<template>
  <div>
    <Card>
      <Table :loading="loading"
             border
             :columns="columns"
             :data="booking_products"
             ref="table"></Table>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      id: this.$route.params.id,
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_bookings_detail_222'),
          key: 'fresh_product_name',
          align: 'center'
        },
        {
          title: i18n.t('pages_bookings_detail_223'),
          key: 'stocks',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_bookings_detail_224'),
          key: 'jinghuojia',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_bookings_detail_225'),
          key: 'total',
          width: 160,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.booking_products_index({ id: this.$route.params.id })
  },
  computed: {
    ...mapGetters('booking', ['booking_products', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('booking', ['booking_products_index'])
  }
}
</script>
